"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_TYPE = exports.MCK_DOMAIN = exports.EXTERNAL_PREFIX = void 0;
const USER_TYPE = exports.USER_TYPE = {
  MCK: 'mck',
  MCK_EXT: 'mck-ext',
  CLIENT: 'client'
};
const EXTERNAL_PREFIX = exports.EXTERNAL_PREFIX = 'external';
const MCK_DOMAIN = exports.MCK_DOMAIN = 'mckinsey.com';